import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The Godot editor workspace a canvas hosts (ADR-0006): '3d' draws only Node3D
 * content, '2d' only CanvasItem content, as in Godot's editor. The dispatcher
 * drops the other kind's subtrees. The default is '3d'.
 */
import { createContext, useContext } from 'react';
const CanvasWorkspaceContext = createContext('3d');
CanvasWorkspaceContext.displayName = 'CanvasWorkspaceContext';
export function CanvasWorkspaceProvider({ workspace, children, }) {
    return _jsx(CanvasWorkspaceContext.Provider, { value: workspace, children: children });
}
export function useCanvasWorkspace() {
    return useContext(CanvasWorkspaceContext);
}
//# sourceMappingURL=CanvasWorkspaceContext.js.map